import React from 'react';
import { useTheme } from '../../context/ThemeContext';

/**
 * Approved outlined wordmarks from the logo package. Gold on dark,
 * ink on light, black on paperwhite. Gold on white is not allowed.
 * These files are outlined; do not retype the name in a font.
 */
const FILES = {
  header: {
    dark: 'brainstormy-wordmark-no-tagline-gold.svg',
    light: 'brainstormy-wordmark-no-tagline-ink.svg',
    paperwhite: 'brainstormy-wordmark-no-tagline-black.svg',
  },
  auth: {
    dark: 'brainstormy-wordmark-tagline-gold.svg',
    light: 'brainstormy-wordmark-tagline-ink.svg',
    paperwhite: 'brainstormy-wordmark-tagline-black.svg',
  },
};

export function wordmarkFile(placement, mode) {
  const set = FILES[placement] || FILES.header;
  if (mode === 'light') return set.light;
  if (mode === 'paperwhite') return set.paperwhite;
  return set.dark;
}

export function wordmarkUrl(placement, mode) {
  const base = process.env.PUBLIC_URL || '';
  return `${base}/brand/${wordmarkFile(placement, mode)}`;
}

export default function Wordmark({ placement = 'header', className }) {
  const { mode } = useTheme();
  return (
    <img
      className={className}
      src={wordmarkUrl(placement, mode)}
      alt="Brainstormy"
    />
  );
}
